import { useTranslation } from "react-i18next";
import "../../i18n";
import { Notice } from "../../design/components";
import { historyFilename, useHistoryExport } from "../../api/history";
import type { DocumentFilters } from "../../api/types";
import { saveBlob } from "../../lib/saveBlob";
import type { QueueFilterState } from "./QueueFilters";

/** The state vocabulary the queue endpoint answers on (m4-rulings.md #50). */
const QUEUE_STATES = new Set(["in_flight", "done", "error", "held", "landed"]);

/** A free-text search, either date bound or a state the queue does not serve needs /api/history. */
export function isHistoryQuery(filters: QueueFilterState): boolean {
  if (filters.q || filters.from || filters.to) return true;
  return Boolean(filters.state) && !QUEUE_STATES.has(filters.state);
}

export function ExportHistoryButton({ filters }: { filters: DocumentFilters }) {
  const { t } = useTranslation();
  const exportCsv = useHistoryExport();

  // The mutation renders its own failure Notice, so a rejection here needs no rethrow.
  function handleClick(): void {
    exportCsv.mutate(filters, { onSuccess: (blob) => saveBlob(blob, historyFilename(filters)) });
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-sm"
        disabled={exportCsv.isPending}
        onClick={handleClick}
      >
        {exportCsv.isPending
          ? t("documents.history.preparing", "Preparing…")
          : t("documents.history.exportCsv", "Export CSV")}
      </button>
      {exportCsv.isError ? (
        <Notice kind="fail">{t("documents.history.exportError", "The export could not be prepared.")}</Notice>
      ) : null}
    </>
  );
}
